import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AllocationsResponse } from '../../../../../models/api/view/claim/details/general-liability/allocations-response';
import { ClaimRow } from '../../../../../models/api/view/claim-view/claim-row';
import { BaseComponent } from '../../../../base/base.component';
import { DetailItemComponent } from '../../../../core/panels/detail-panel/detail-item.component';
import { DetailPanelComponent } from '../../../../core/panels/detail-panel/detail-panel.component';
import { ColumnComponent } from '../../../../core/table/column.component';
import { TableComponent } from '../../../../core/table/table.component';

@Component({
  selector: 'app-allocations-gl',
  imports: [
    DetailPanelComponent,
    DetailItemComponent,
    TableComponent,
    ColumnComponent,
    RouterModule,
  ],
  template: `
    <div class="tw-flex tw-w-full tw-gap-8 tw-py-4">
      <app-detail-panel [dataSource]="dataSource" class="tw-basis-1/3">
        <app-detail-item
          label="Total indemnity percent"
          name="totalIndemnityPercent"
          format="%"
        />
        <app-detail-item
          label="Total expense percent"
          name="totalExpensePercent"
          format="%"
        />
      </app-detail-panel>
    </div>
    <app-table
      [dataSource]="dataSource?.allocations"
      [pageSize]="5"
      [scrollable]="false"
      [expandable]="true"
      dataKey="providerName"
      recordLabel="Allocation"
      [sortField]="'providerName'"
      [sortOrder]="1"
      ariaTableLabel="Allocations"
    >
      <app-column name="providerName" label="Provider name" />
      <app-column name="providerType" label="Provider type" />
      <app-column
        name="indemnityPercent"
        label="Indemnity percent"
        format="%"
      />
      <app-column name="expensePercent" label="Expense percent" format="%" />

      <ng-template #expand let-data>
        <div class="tw-flex tw-gap-8">
          <div class="tw-basis-1/3">
            <app-detail-panel [dataSource]="data">
              <app-detail-item label="Email" name="email" />
              <app-detail-item label="License number" name="licenseNumber" />
              <app-detail-item label="Phone" name="phone" />
              <app-detail-item label="Address" name="address" />
            </app-detail-panel>
          </div>
          <div class="tw-basis-1/3">
            <app-detail-panel [dataSource]="data">
              <app-detail-item
                label="Date effective"
                name="dateEffective"
                format="d"
              />
              <app-detail-item
                label="Date expire"
                name="dateExpire"
                format="d"
              />
              <app-detail-item label="Specialty" name="specialty" />
              <app-detail-item label="Staff type" name="staffType" />
            </app-detail-panel>
          </div>
        </div>
      </ng-template>
    </app-table>
  `,
  styles: ``,
})
export class AllocationsGlComponent extends BaseComponent implements OnInit {
  dataSource: AllocationsResponse;

  async ngOnInit(): Promise<void> {
    await this.loadData();
  }

  private async loadData(): Promise<void> {
    const claim: ClaimRow = this.view.currentClaim();
    this.dataSource = await this.api.generalLiability.getAllocations({
      recordSource: claim.recordSource,
      recordId: claim.recordId,
    });
  }
}
